module.exports = __webpack_public_path__ + "5057d9802035b7cd764d963467f96552.otf";